import type { Locale, ToolDefinition } from '../domain/tools/types';

const arabicDiacritics = /[\u0610-\u061a\u064b-\u065f\u0670\u06d6-\u06ed]/gu;

export function normalizeSearch(value: string): string {
  return value
    .normalize('NFKD')
    .toLocaleLowerCase()
    .replace(arabicDiacritics, '')
    .replace(/ـ/gu, '')
    .replace(/[أإآٱ]/gu, 'ا')
    .replace(/ى/gu, 'ي')
    .replace(/ؤ/gu, 'و')
    .replace(/ئ/gu, 'ي')
    .replace(/[،,;؛:_/\\|()[\]{}+\-–—]+/gu, ' ')
    .replace(/\s+/gu, ' ')
    .trim();
}

export function toolSearchText(tool: ToolDefinition): string {
  return normalizeSearch([
    tool.name.en,
    tool.name.ar,
    tool.description.en,
    tool.description.ar,
    ...tool.tags.flatMap((tag) => [tag.en, tag.ar]),
    tool.id,
    tool.category,
  ].join(' '));
}

export function searchTools(tools: readonly ToolDefinition[], query: string, locale: Locale): readonly ToolDefinition[] {
  const terms = normalizeSearch(query).split(' ').filter(Boolean);
  if (terms.length === 0) return tools;

  return tools
    .map((tool) => {
      const haystack = toolSearchText(tool);
      const exactName = normalizeSearch(tool.name[locale]);
      const matches = terms.every((term) => haystack.includes(term));
      const score = matches
        ? terms.reduce((total, term) => total + (exactName.startsWith(term) ? 4 : exactName.includes(term) ? 2 : 1), 0)
        : -1;
      return { tool, score };
    })
    .filter(({ score }) => score >= 0)
    .sort((a, b) => b.score - a.score || a.tool.name[locale].localeCompare(b.tool.name[locale], locale))
    .map(({ tool }) => tool);
}
